export default "/_next/static/6924fb5d52f5653489fa3c8e765872b3.png";